import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React, {useRef, useState} from 'react';
import InlineMessages from '../../containers/inline-messages.jsx';
import {filterInlineAlerts} from '../../reducers/alerts';
import VM from 'scratch-vm';

import styles from './save-status.css';

const TWProjectUploader = ({alertsList, projectChanged, projectId}) => {
    const [saveStatusText, setSaveStatusText] = useState(
        <FormattedMessage
            defaultMessage="Save Now"
            description="Button to upload project to server"
            id="tw.menuBar.saveNow"
        />
    );

    const fileInputRef = useRef(null); // Reference to the hidden file input

    const handleSaveClick = () => {
        if (!new URLSearchParams(window.location.search).get('username')) {
            setSaveStatusText('Login To Save!');
            return;
        } 
        handleFileChange();
    };

    const handleFileChange = async (event) => {

        setSaveStatusText('Saving...');

        try {
            const blob = await vm.saveProjectSb3();
            const projectFile = new File([blob], 'project.sb3', {type: 'application/zip'});
            const formData = new FormData();
            formData.append('project', projectFile);

            const currentProjectId = projectId || window.location.hash.substring(1);
            const metaRes = await fetch(`https://sl-api-v1.onrender.com/api/projects/${currentProjectId}/meta/${new URLSearchParams(window.location.search).get('username')}`);
            const meta = await metaRes.json();

            if (meta.error) {
                console.error(meta.error);
                setSaveStatusText('Save Failed!');
                return;
            }

            formData.append('projectName', meta.title);

            if (meta.author?.username === new URLSearchParams(window.location.search).get('username')) {
                const uploadEndpoint = `https://sl-api-v1.onrender.com/${currentProjectId}/save`;
                const uploadRes = await fetch(uploadEndpoint, {
                    method: 'POST',
                    body: formData
                });
                const res = await uploadRes.json();

                if (res.error) {
                    console.error(res.error);
                    setSaveStatusText('Save Failed!');
                    return;
                }

                console.log('Project uploaded successfully.');
                setSaveStatusText('Saved!');
            } else {
                console.warn('Not authorized to upload this project.');
                setSaveStatusText("Not authorized!");
            }
        } catch (error) {
            console.error('Failed to upload project:', error);
            setSaveStatusText('Save Failed!');
        }

        setTimeout(() => {
            setSaveStatusText(
                <FormattedMessage
                    defaultMessage="Save Now"
                    description="Button to upload project to server"
                    id="tw.menuBar.saveNow"
                />
            );
        }, 3000);
    };

    if (filterInlineAlerts(alertsList).length > 0) {
        return <InlineMessages />;
    }

    return (
        <div>
            <div onClick={handleSaveClick} className={styles.saveNow}>
                {saveStatusText}
            </div>
        </div>
    );
};

TWProjectUploader.propTypes = {
    alertsList: PropTypes.arrayOf(PropTypes.object),
    projectChanged: PropTypes.bool,
    projectId: PropTypes.string
};

const mapStateToProps = state => ({
    alertsList: state.scratchGui.alerts.alertsList,
    projectChanged: state.scratchGui.projectChanged, 
    projectId: state.scratchGui.projectState.projectId
});

export default connect(
    mapStateToProps,
    () => ({})
)(TWProjectUploader);
